var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showBulkDownload
    ? _c(
        "modal-box",
        {
          attrs: { open: _vm.showBulkDownload },
          domProps: {
            onClose: _vm.hideBulkDownload,
            enableHeader: true,
            enableFooter: true,
            enableHeaderClose: true,
            transparentOverlay: false,
            closeOnClickOutside: true,
          },
        },
        [
          _vm.dataLoading
            ? _c("div", { staticClass: "popup" }, [_c("eas-loader")], 1)
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", { staticClass: "flex-row flex-1" }, [
                _c("div", { staticClass: "flex-col flex-1" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("exportXlsx")))]),
                ]),
              ]),
            ]
          ),
          _vm.validYears.length === 0 && !_vm.dataLoading
            ? _c("div", { staticClass: "errors" }, [
                _c("div", { staticClass: "bulk-download-section-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("noRunsWithFrozenDataForCurrentAssetSelection")
                      ) +
                      " "
                  ),
                ]),
              ])
            : !_vm.dataLoading
            ? _c("div", { staticClass: "scrollable" }, [
                _c("div", { staticClass: "flex-col pr-1" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex-row mb-2 bulk-download-section-title",
                      attrs: { title: _vm.checkedAssetNames },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("numberOfSelectedAssets")) +
                          " " +
                          _vm._s(_vm.checkedAssets.length) +
                          " "
                      ),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "flex-col pr-1" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-row mb-2 bulk-download-section-title",
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("reportSections")) + " ")]
                    ),
                    _c("label", { staticClass: "checkbox-container" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.allComponentsAreChecked,
                            expression: "allComponentsAreChecked",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.allComponentsAreChecked)
                            ? _vm._i(_vm.allComponentsAreChecked, null) > -1
                            : _vm.allComponentsAreChecked,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.allComponentsAreChecked,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.allComponentsAreChecked = $$a.concat([
                                    $$v,
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.allComponentsAreChecked = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.allComponentsAreChecked = $$c
                            }
                          },
                        },
                      }),
                      _c("span", { staticClass: "select-all-components" }, [
                        _vm._v(_vm._s(_vm.$t("selectAll"))),
                      ]),
                      _c("span", { staticClass: "checkmark" }),
                    ]),
                    _vm._l(_vm.componentList, function (componentTitle, index) {
                      return _c(
                        "label",
                        { key: index, staticClass: "checkbox-container" },
                        [
                          _c("div", { staticClass: "flex-row flex-4" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.checkedComponents,
                                  expression: "checkedComponents",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: componentTitle.id,
                                checked: Array.isArray(_vm.checkedComponents)
                                  ? _vm._i(
                                      _vm.checkedComponents,
                                      componentTitle.id
                                    ) > -1
                                  : _vm.checkedComponents,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.checkedComponents,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = componentTitle.id,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.checkedComponents = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.checkedComponents = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.checkedComponents = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(
                              " " + _vm._s(componentTitle.component) + " "
                            ),
                            _c("span", { staticClass: "checkmark" }),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _vm.hasEditAccess
                  ? _c("div", { staticClass: "flex-col pr-1" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex-row mb-2 bulk-download-section-title",
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("includeFinalVersion")) + " "
                          ),
                          _c("label", { staticClass: "checkbox-container" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.includeFinalVersion,
                                  expression: "includeFinalVersion",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.includeFinalVersion)
                                  ? _vm._i(_vm.includeFinalVersion, null) > -1
                                  : _vm.includeFinalVersion,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.includeFinalVersion,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.includeFinalVersion = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.includeFinalVersion = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.includeFinalVersion = $$c
                                  }
                                },
                              },
                            }),
                            _c("span", { staticClass: "checkmark" }),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "flex-col pr-1" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-row mb-2 bulk-download-section-title",
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("reportYearSelection")) + " "
                        ),
                      ]
                    ),
                    _vm.containsAssetWithNoDataFreezeRuns
                      ? _c("div", { staticClass: "warnings" }, [
                          _c(
                            "ul",
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "noRunsWithFrozenDataForCurrentExportSelection"
                                    )
                                  ) +
                                  ": "
                              ),
                              _vm._l(_vm.checkedYears, function (year, i) {
                                return [
                                  _vm.containsAssetWithNoDataFreezeRunsForYear(
                                    year
                                  )
                                    ? _c(
                                        "li",
                                        { key: i },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-weight": "bold",
                                              },
                                            },
                                            [_vm._v(" " + _vm._s(year) + ": ")]
                                          ),
                                          _vm._l(
                                            _vm.assetsWithNoFrozenData(year),
                                            function (asset, j) {
                                              return _c("div", { key: j }, [
                                                _vm._v(
                                                  " " + _vm._s(asset.name) + " "
                                                ),
                                              ])
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                    _vm._l(_vm.validYears, function (year, index) {
                      return _c(
                        "label",
                        { key: index, staticClass: "checkbox-container" },
                        [
                          _c("div", { staticClass: "flex-row flex-4" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.checkedYears,
                                  expression: "checkedYears",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: year,
                                checked: Array.isArray(_vm.checkedYears)
                                  ? _vm._i(_vm.checkedYears, year) > -1
                                  : _vm.checkedYears,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.checkedYears,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = year,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.checkedYears = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.checkedYears = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.checkedYears = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" " + _vm._s(year) + " "),
                            _vm.containsAssetWithNoDataFreezeRunsForYear(year)
                              ? _c(
                                  "span",
                                  { staticClass: "icon-container" },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "fa",
                                      attrs: {
                                        icon: ["fas", "exclamation-triangle"],
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("span", { staticClass: "checkmark" }),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.validYears.length > 0
                ? _c("div", { staticClass: "flex-row reverse" }, [
                    _c("div", { staticClass: "flex-col flex-align-end mt-1" }, [
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn",
                            on: {
                              click: function ($event) {
                                return _vm.hideBulkDownload()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn",
                            attrs: { disabled: _vm.exportButtonDisabled },
                            on: {
                              click: function ($event) {
                                return _vm.download()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("export")) + " ")]
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }